/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-16 10:03:08
 * @LastEditTime: 2019-08-29 15:47:34
 * @LastEditors: Please set LastEditors
 */

import AxiosConfig from "../../../config/AxiosConfigJs";
import { BusTransferInfo } from "../BusTransfer/Model/BusTransferInfo";
import { BusTransferType } from "../BusTransfer/Model/BusTransferType";

/// <summary>
/// 公交换乘服务
/// </summary>
export class BusTransferService {


	constructor() {
		this.endPositionX = -1;
		this.endPositionY = -1;
		this.startPositionX = -1;
		this.startPositionY = -1;
		this.tdtURL = "http://api.tianditu.gov.cn/transit";
		this.transferType = BusTransferType.LessTransfer;
		this.token = null;
	}

	/**
			 *换乘
			 */
	Transfer(succeedCallback, errorCallback) {

		let postString = "{'startposition':'" + this.startPositionX + "," + this.startPositionY + "','endposition':'" + this.endPositionX + "," + this.endPositionY + "','linetype':'" + this.transferType + "'}";

		AxiosConfig.nationalTDTConfig
			.get(this.tdtURL, { params: { random: Math.random(), postStr: postString, type: "busline", tk: this.token } })
			.then(function (response) {
				if (response != null) {
					let resultObj = response.data;
					let transferInfo = BusTransferInfo.GetTransferInfo(resultObj);
					if (succeedCallback) {
						succeedCallback(transferInfo);
					}
				}
			})

			.catch(function (error) {
				if (errorCallback) {
					errorCallback(error.message);
				}

			});
	}

	/**
	 * 测试用
	 */
	static test() {
		let bus = new BusTransferService();
		bus.startPositionX = 116.427562;
		bus.startPositionY = 39.939677;
		bus.endPositionX = 116.349329;
		bus.endPositionY = 39.939132;
		bus.token = "ebddfc3f34215c7375bddd93f03dd684";

		bus.Transfer(null, null);
	}

}//end BusTransferService